import { environment } from '@environments/environment';

export const baseUri = `${environment.apiUri}/transaction/:transactionId/services/water-transfer-document`;
export const baseUriActive = `${baseUri}/active`;
export const baseUriSubmit = `${baseUri}/submit`;
export const baseUriAttachments = `${baseUri}/attachments`;
export const baseUriGenerateWaterTransferDocument = `${baseUri}/generate-water-transfer-document`;

export const suppliersUri = `${environment.apiUri}/water/water-suppliers`;
